import styled from 'styled-components';

export const GameDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-right: auto;
    min-width: 0;
`;

export const TeamName = styled.span`
    font-size: 0.82rem;
    font-weight: 600;
    color: #e2e8f0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const GameDate = styled.span`
    font-size: 0.68rem;
    color: #94a3b8;
    font-weight: 500;
    margin-bottom: 1px;
`;

export const ClickableGameListItem = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.7rem;
    border-bottom: 1px solid rgba(255,255,255,0.06);
    border-left: 3px solid ${({ color }) =>
        color === 'success' ? '#22c55e' :
        color === 'danger'  ? '#ef4444' :
        'rgba(255,255,255,0.12)'};
    background: ${({ color }) =>
        color === 'success' ? 'rgba(34,197,94,0.06)'  :
        color === 'danger'  ? 'rgba(239,68,68,0.06)'  :
        'transparent'};
    transition: background 0.15s ease;
    &:last-child { border-bottom: none; }
    &:hover { background: rgba(59,130,246,0.1); }
`;

export const GameResult = styled.span`
    font-size: 0.76rem;
    font-weight: 700;
    color: ${({ color }) =>
        color === 'success' ? '#4ade80' :
        color === 'danger'  ? '#f87171' :
        '#94a3b8'};
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const ScheduleCard = styled.div`
    border: 1px solid rgba(255,255,255,0.09);
    border-radius: 12px;
    background: rgba(255,255,255,0.03);
    overflow: hidden;
    margin-bottom: 0.5rem;
`;

export const RecordRow = styled.div`
    display: flex;
    gap: 0.4rem;
    padding: 0.3rem 0.55rem 0.25rem;
`;

export const RecordBadge = styled.div`
    font-size: 0.62rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 6px;
    padding: 0.25rem 0.45rem;
    label { color: #94a3b8; margin: 0; margin-right: 4px; font-weight: 700; }
    span  { color: #e2e8f0; }
`;
